import BaseApi from './BaseApi';

import LeaseClauseModel from '../models/LeaseClause';
import ContractAddendumClause from 'src/components/project/sections/LeasingComponents/redesign/ContractGenerationModels/ContractAddendumClause';
import LandContractType from 'src/models/LandContractType';

export interface ILeaseClause {
    getAll(clientNumber: number, projectId: number, jwt: string): Promise<object>;
    create(clientNumber: number, projectId: number, clause: LeaseClauseModel, jwt: string): Promise<object>;
    update(clientNumber: number, projectId: number, clause: LeaseClauseModel, jwt: string): Promise<object>;
    delete(clientNumber: number, projectId: number, id: number, jwt: string): Promise<object>;
    getContractClauses(clientNumber: number, projectId: number, jwt: string): Promise<object>;
    getProvisionClauseTypes (clientNumber: number, projectId: number, jwt: string, contractType: LandContractType): Promise<object>;
    getProvisionValues (clientNumber: number, projectId: number, jwt: string): Promise<object>;
    getProvisionUnits (clientNumber: number, projectId: number, jwt: string): Promise<object>;
    deleteProvisionClauseType (clientNumber: number, projectId: number, provisionClauseId: number, jwt: string): Promise<object>;
    createContractClause(clientNumber: number, projectId: number, clause: ContractAddendumClause, jwt: string): Promise<object>;
    updateContractClause(clientNumber: number, projectId: number, clause: ContractAddendumClause, jwt: string): Promise<object>;
    deleteContractClause(clientNumber: number, projectId: number, id: number, jwt: string): Promise<object>;
}

export default class LeaseClause extends BaseApi implements ILeaseClause {
    constructor(baseUrl: string) {
        super(baseUrl);
    }

    public getAll = (clientNumber: number, projectId: number, jwt: string) => {
        return this.getRequest(`${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectId}/clauses`, jwt);
    };

    public create = (clientNumber: number, projectId: number, clause: LeaseClauseModel, jwt: string) => {
        return this.postRequest(`${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectId}/clauses`, clause, jwt);
    };

    public update = (clientNumber: number, projectId: number, clause: LeaseClauseModel, jwt: string) => {
        return this.postRequest(`${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectId}/clauses/update`, clause, jwt);
    };

    public delete = (clientNumber: number, projectId: number, id: number, jwt: string) => {
        return this.deleteRequest(`${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectId}/clauses/${id}`, {}, jwt);
    };

    public getContractClauses = (clientNumber: number, projectId: number, jwt: string) => {
        return this.getRequest(`${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectId}/clauses/contract-clauses`, jwt);
    };
    
    public getProvisionClauseTypes = (clientNumber: number, projectId: number, jwt: string ) => {
        return this.getRequest(`${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectId}/provisionLeaseClause/types/get-all`, jwt);
    };
    
    public getProvisionValues = (clientNumber: number, projectId: number, jwt: string) => {
        return this.getRequest(`${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectId}/provisionLeaseClause/values`, jwt);
    };
    
    public getProvisionUnits = (clientNumber: number, projectId: number, jwt: string) => {
        return this.getRequest(`${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectId}/provisionLeaseClause/units`, jwt);
    };

    public deleteProvisionClauseType = (clientNumber: number, projectId: number, provisionClauseId: number, jwt: string) => {
        return this.deleteRequest(`${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectId}/provisionLeaseClause/types/${provisionClauseId}`, {}, jwt);
    };
    
    public createContractClause = (clientNumber: number, projectId: number, clause: ContractAddendumClause, jwt: string) => {
        return this.postRequest(`${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectId}/clauses/contract-clauses`, clause, jwt);
    };

    public updateContractClause = (clientNumber: number, projectId: number, clause: ContractAddendumClause, jwt: string) => {
        return this.putRequest(`${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectId}/clauses/contract-clauses`, clause, jwt);
    };

    public deleteContractClause = (clientNumber: number, projectId: number, id: number, jwt: string) => {
        return this.deleteRequest(`${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectId}/clauses/contract-clauses/${id}`, {}, jwt);
    };
}



// WEBPACK FOOTER //
// ./src/api/Clauses.ts